import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  fetchPosConfig,
  upsertPosConfig,
  type UpsertPosSettingsPayload,
} from '@/services/api/retailPosConfig.api';

export function usePosConfig(propertyId: string | null) {
  return useQuery({
    queryKey: ['pos-settings', propertyId],
    queryFn: () => fetchPosConfig(propertyId as string),
    staleTime: 30_000,
    enabled: !!propertyId,
  });
}

export function useUpsertPosConfig() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: UpsertPosSettingsPayload) => upsertPosConfig(payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['pos-settings'] });
    },
  });
}
